import _ from 'lodash'
export class ValidatorHelper {
    constructor() {
        this.errors = null;
        this.verify = []
        this.typeToString = {
            required: (label) => `${label}`
        }
        this.typeValidValue = {
            required: (values, param) => {
                return _.get(values, param) ? true : false
            }
        }
    }
    addRequired(param, label) {
        this.verify.push({ type: "required", label, param })
    }

    valid(values) {
        let erros = ["Informe o campo:"]
        this.verify.forEach(v => {
            if (!this.typeValidValue[v.type](values, v.param)) {
                if (erros.length === 1) {
                    erros.push(this.typeToString[v.type](" " + v.label))
                } else {
                    erros.push(this.typeToString[v.type](", " + v.label))
                }
            }
        });

        // console.log("erros.length", erros.length)
        
        if (erros.length === 1) {
            return []
        }

        return erros
    }
}